import '@pinflag/pinflag-ui-kit/styles'
import React from 'react'
import { createRoot } from 'react-dom/client'

import { DataProvider } from './context/DataContext'
import { MagentoProvider } from './context/MagentoContext'

import App from './App'
import ErrorBoundary from './ErrorBoundary'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DataProvider>
        <MagentoProvider>
          <App />
        </MagentoProvider>
      </DataProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
